import React, { useEffect } from 'react';
import { addAttribute, htmlToText, trimString, tokenAuthorize, removeIframe, convertDate } from "../../components/Helpers/Common";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import axios from 'axios';
import { serverUrl } from '../../components/Helpers/Config';
import { useState } from 'react';
import { staticFiles } from '../../components/Helpers/Static';
import { Card } from "../Theme";
import Tooltip from '@mui/material/Tooltip';
import moment from "moment";
import Swal from 'sweetalert2';
import { getUrl } from '../../components/Helpers/Config';


const defaultCoverImg = staticFiles.coverDefault;

export default function ProfileCard({ data, noProfile, handleProfilePage }) {

    const [profile, setProfile] = useState(null);
    const [cover, setCover] = useState(null);

    useEffect(() => {
        axios.get(serverUrl.ShowcaseGalleryImage + data?.guid).then(res => {
            setProfile(res.data?.profile_image);
            setCover(res.data?.cover_image)
        })
    }, [])



    return (
        <div className='cardBackgroundColor shadow-sm border20px overflow-hidden relative cursor-pointer w-full' onClick={() => handleProfilePage(data.guid)}>
            <div className='bg-white h-24 objectfit-cover background-repeatimage backimage-size background-image-grid-no' style={{ backgroundImage: cover ? "url(" + cover + ")" : "url(" + defaultCoverImg + ")", backgroundColor: (cover != null && cover != "") ? "" : true ? '#7dea7d' : '#58a6e7' }}>
            </div>
            <div className='block relative -top-16 ml-auto mr-auto hover:no-underline'>
                {/* < Link to={"/profile/" + data.guid} target="_blank"> */}
                <img src={profile ? profile : noProfile} className="w-24 h-24 rounded-lg object-cover ml-auto mr-auto" />
                {/* </Link> */}
            </div>
            <div className='-mt-14'>
                <p className='text-center text-lg blackColor font-semibold'>{data?.fullname}</p>
                {data.last_updated_on && <p className='text-center text-base lightColor'>Last Updated : <span className='font-semibold blackColor'>{data.last_updated_on !== null ? moment.utc(data.last_updated_on).local().startOf('seconds').fromNow() : "-"}</span></p>}
                {data?.programme_category && <Tooltip title={data?.programme_category} placement="right" arrow><p className='text-center text-base h-6 truncate px-3 blackColor'>{data?.programme_category}</p></Tooltip>}
                {data?.public_reflection_count != null && <p className='text-center text-base lightColor'>Public Reflection Count : <span className='font-semibold blackColor'>{data?.public_reflection_count}</span></p>}
                <div className="text-viewer px-3 py-2 break-words overflow-hidden">
                    <div className="multiline-ellipsis6" dangerouslySetInnerHTML={{ __html: removeIframe(data?.about_me?.reflection_content ? data?.about_me?.reflection_content : "") }} />
                </div>
            </div>

        </div>
    )
}
